import Moment from "moment-jalaali";

const separateNum = (num, sep, string) => {
  if (num) {
    var number = typeof num === "number" ? num.toString() : num,
      separator = typeof sep === "undefined" ? "," : sep ? sep : ",";

    return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separator);
  } else {
    return string ? "" : 0;
  }
};

const getAge = (dateString) => {
  var now = new Date();

  var yearNow = now.getYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();

  var dob = new Date(dateString);

  var yearDob = dob.getYear();
  var monthDob = dob.getMonth();
  var dateDob = dob.getDate();
  var age = {};
  var ageString = "";
  var yearString = "";
  var monthString = "";
  var dayString = "";
  var dateAge;
  var monthAge;

  var yearAge = yearNow - yearDob;

  if (monthNow >= monthDob) monthAge = monthNow - monthDob;
  else {
    yearAge--;
    monthAge = 12 + monthNow - monthDob;
  }

  if (dateNow >= dateDob) dateAge = dateNow - dateDob;
  else {
    monthAge--;
    dateAge = 31 + dateNow - dateDob;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }

  age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  };

  if (age.years > 1) yearString = " سال";
  else yearString = " سال";
  if (age.months > 1) monthString = " ماه";
  else monthString = " ماه";
  if (age.days > 1) dayString = " روز";
  else dayString = " روز";

  if (age.years > 0 && age.months > 0 && age.days > 0)
    ageString =
      age.years +
      yearString +
      " " +
      age.months +
      monthString +
      " " +
      age.days +
      dayString;
  else if (age.years === 0 && age.months === 0 && age.days > 0)
    ageString = age.days + dayString;
  else if (age.years > 0 && age.months === 0 && age.days === 0)
    ageString = age.years + yearString;
  else if (age.years > 0 && age.months > 0 && age.days === 0)
    ageString = age.years + yearString + " " + age.months + monthString;
  else if (age.years === 0 && age.months > 0 && age.days > 0)
    ageString = age.months + monthString + " " + age.days + dayString;
  else if (age.years > 0 && age.months === 0 && age.days > 0)
    ageString = age.years + yearString + " " + age.days + dayString;
  else if (age.years === 0 && age.months > 0 && age.days === 0)
    ageString = age.months + monthString;
  else ageString = "0";

  return ageString;
};

const getToday = () => {
  var date = new Date();

  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();

  if (month < 10) {
    month = `0${month}`;
  }

  if (day < 10) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
};

const getBackWeek = () => {
  var date = Moment(new Date()).add(-7, "days").toDate();

  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();

  if (month < 10) {
    month = `0${month}`;
  }

  if (day < 10) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
};

const getDayPersian = (date) => {
  Moment.loadPersian({ usePersianDigits: false });

  return Moment(date, "YYYY-MM-D").format("jYYYY/jM/jD");
};

const formData = (data) => {
  var newData = {};
  for (var i = 0; i < Object.keys(data).length; i++) {
    if (data[Object.keys(data)[i]] !== "") {
      newData[Object.keys(data)[i]] = data[Object.keys(data)[i]];
    }
  }

  return newData;
};

const secondsToTime = (secs) => {
  let hours = Math.floor(secs / (60 * 60));

  let divisor_for_minutes = secs % (60 * 60);
  let minutes = Math.floor(divisor_for_minutes / 60);

  let divisor_for_seconds = divisor_for_minutes % 60;
  let seconds = Math.ceil(divisor_for_seconds);

  let obj = {
    h: hours,
    m: minutes,
    s: seconds,
  };
  return obj;
};

export {
  separateNum,
  getAge,
  getToday,
  getDayPersian,
  getBackWeek,
  formData,
  secondsToTime,
};
